module.exports = __webpack_public_path__ + "flyer_background_gold_cocktails_073-7f4af590c13d71808e2f384fc9f25896.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_gold_cocktails_073.jpg
// module id = 1652
// module chunks = 1